/**
 * HORIZONLOOK logo mark — a minimalist "radio horizon": signal arcs rising over a
 * horizon line. Uses currentColor so it inherits white in the (dark blue) header
 * and the brand colour elsewhere. The same mark is the favicon (public/favicon.svg).
 */
export function Logo({ size = 26 }: { size?: number }) {
  return (
    <svg
      viewBox="0 0 48 48"
      width={size}
      height={size}
      role="img"
      aria-label="HORIZONLOOK"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.6}
      strokeLinecap="round"
    >
      <line x1="9" y1="31" x2="39" y2="31" />
      <path d="M16 31 a8 8 0 0 1 16 0" />
      <path d="M10 31 a14 14 0 0 1 28 0" />
      <path d="M4 31 a20 20 0 0 1 40 0" />
      <circle cx="24" cy="31" r="2.6" fill="currentColor" stroke="none" />
    </svg>
  );
}
